import { Dialog, DialogContent, DialogTitle, DialogActions, Button } from '@material-ui/core'
import axios from 'axios'
import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import Swal from 'sweetalert2'
import Constant from '../../Constant'

class EditBooking extends Component {
  state = {
    isLoading: false,
    comments: '',
    confirmed_booking_date: '',
    status: '',
  }

  componentDidMount() {
    var dataByID = this.props.userdata
    let dateElements = new Date(dataByID[0]?.confirmed_booking_date).toLocaleDateString().split('/')

    this.setState({
      confirmed_booking_date: `${dateElements[2]}-${dateElements[1]}-${dateElements[0]}`,
      status: dataByID[0]?.booking_status,
      comments: dataByID[0]?.comments,
    })
  }

  handleChange = (event) => {
    this.setState({ [event.target.name]: event.target.value })
  }

  handleUpdate = async () => {
    if (this.state.confirmed_booking_date === '' || this.state.status === '') {
      this.props.handleClose()
      return Swal.fire('Oops !', 'Confirm booking date and status fields are required', 'error')
    }
    this.setState({
      isLoading: true,
    })
    var data = {
      bookingId: this.props.popBookID,
      comments: this.state.comments,
      confirmed_booking_date: this.state.confirmed_booking_date,
      booking_status: this.state.status,
    }
    await axios
      .post(Constant.getAPI() + '/booking/update-booking-status', data, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.status === 200) {
          Swal.fire('Updated !', 'Booking has been Updated', 'success')
          this.props.getBookingList()
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
      .finally(() => {
        this.setState({
          isLoading: true,
        })
        this.props.handleClose()
      })
  }

  render() {
    return (
      <Dialog
        fullWidth={true}
        maxWidth={'sm'}
        open={this.props.openDailog}
        onClose={this.props.handleClose}
      >
        <DialogTitle>Edit Bookings</DialogTitle>
        <DialogContent>
          <div
            className="form-group col"
            style={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'center',
            }}
          >
            <label className="col-sm-5 col-form-label">Confirmed Booking Date </label>
            <input
              type="date"
              className="form-control col-md-7"
              name="confirmed_booking_date"
              placeholder="Confirmed Booking Date"
              required
              onChange={this.handleChange}
              value={this.state.confirmed_booking_date}
            />
          </div>
          <div
            className="form-group col"
            style={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'center',
            }}
          >
            <label className="col-sm-5 col-form-label">Status</label>
            <select
              className="form-control col-md-7"
              onChange={this.handleChange}
              value={this.state.status}
              required
              name="status"
            >
              <option value={''}>Select Status</option>
              <option value={'Confirmed'}>Confirmed</option>
              <option value={'Cancelled'}>Cancelled</option>
              <option value={'Successful'}>Successful</option>
              <option value={'Pending'}>Pending</option>
            </select>
          </div>

          <div
            className="form-group col"
            style={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'center',
            }}
          >
            <label className="col-sm-5 col-form-label">Comments </label>
            <textarea
              type="text"
              className="form-control col-md-7"
              name="comments"
              placeholder="Comments"
              onChange={this.handleChange}
              value={this.state.comments}
            />
          </div>
        </DialogContent>
        <DialogActions>
          <div className="row float-right p-3">
            <Link
              className="btn btn-outline-dark mr-2"
              onClick={this.props.handleClose}
            >
              Close
            </Link>
            <Button
              className="btn btn-grd-disabled mr-2"
              onClick={this.handleUpdate}
              disabled={this.state.isLoading}
            >
              {this.state.isLoading ? 'Updating...' : 'Update'}
            </Button>
          </div>
        </DialogActions>
      </Dialog>
    )
  }
}
export default EditBooking
